import axios from "axios";

const axiosPost = axios.post;

axios.post = (...args) => {
    if (args[0]) {
        args[0] = args[0].replace(/([^:]\/)\/+/g, "$1");
    }

    return axiosPost(...args);
}

export default axios;
